export const iconFontAwesomeReligionSpaghettiMonsterFlying = (
	<i className="fa-solid fa-spaghetti-monster-flying"></i>
);
